import { Button } from "react-bootstrap";
import styled, { css } from "styled-components";

/**
 * Adds extra styling to the normal bootstrap buttons
 */
const ModalButton = styled(Button).attrs({ block: true })<{ $hasNoBorder: boolean }>`
  ${({ $hasNoBorder }) =>
    $hasNoBorder
      ? css`
          border: none;
        `
      : css`
          padding: 12px 24px;
        `}
`;

export default ModalButton;
